module.exports = __webpack_public_path__ + "img/92ne.26397a25.svg";